"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSplunkPassport = exports.SplunkPassportDefault = void 0;
var _uuid = require("uuid");
var initSplunkPassport = exports.initSplunkPassport = function initSplunkPassport() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    server: "",
    isConnected: false
  };
};
var SplunkPassportDefault = exports.SplunkPassportDefault = function SplunkPassportDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    server: "",
    isConnected: false
  };
};